<template>
  <v-card>

    <v-dialog v-model="dialogCloseChat" persistent max-width="320" v-if="checkForMotif && !hasMotif">
      <v-card>
        <v-card-title class="primary white--text subheading">{{ $t('closeChatTitle') }}</v-card-title>
        <v-card-text>{{ $t('tagBeforeClose') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click="fermeDialog()">{{ $t('cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogCloseChat" persistent max-width="500" v-else>
      <v-card>
        <v-card-title class="primary white--text subheading">{{ $t('closeChatTitle') }}</v-card-title>
        <v-card-text>{{ $t('beforeCloseOptions') }}</v-card-text>
        <v-card-text v-if="$route.fullPath !== '/trafic/attente'">
          <v-switch
            :disabled="checkSatisfaction"
            :label="$t('sendSatisfactionSurvey')"
            v-model="formulaireSatisfaction"
            hide-details
          ></v-switch>
        </v-card-text>
        <v-card-text>
          <v-switch
            :label="$t('closeThisChat')"
            v-model="clotureChat"
            :hint="$t('closeThisChatHint')"
            persistent-hint
          ></v-switch>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click="fermeDialog()">{{ $t('cancel') }}</v-btn>
          <v-btn class="blue--text darken-1" flat @click="fermeChat()">{{ $t('close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      checkForMotif: false,
      formulaireSatisfaction: false,
      clotureChat: false
    }
  },

  props: ['datasVisiteur', 'dialogCloseChat'],

  methods: {
    ...mapActions('_StoreWatcheeBox', [
      'ACTION_CLOSE_CHAT'
    ]),

    // ----------------------------------------------------------------------------
    // close la dialogBox
    // ----------------------------------------------------------------------------
    fermeDialog () {
      // ferme le chat
      this.$emit('fermeDialogCloseChat', {
        dialogCloseChat: false
      })
    },

    // ----------------------------------------------------------------------------
    // ouvre la dialogBox 'fermeChat' sur le btn dans la div de deconnexion .offlineVisiteur
    // quant le visiteur n'est plus la
    // ----------------------------------------------------------------------------
    // fermeChat () {
      // met à jour les switch en regardant les cookies
      // this.settingsFromCookies()
      // ouvre la dialogBox
      // this.dialogCloseChat = true
    // },

    // ----------------------------------------------------------------------------
    // ferme le chat
    // avec option envois formulaire de satisfaction
    // et cloture de chat
    // c'est un message de type 4
    // ----------------------------------------------------------------------------
    fermeChat () {
      console.log('path : ', this.formulaireSatisfaction)
      // jamais d'envois de formulaire de satisfaction dans la section "attente"
      if (this.$route.fullPath === '/trafic/attente') {
        this.formulaireSatisfaction = false
      }
      this.ACTION_CLOSE_CHAT({
        formulaireSatisfaction: this.formulaireSatisfaction,
        datasVisiteur: this.datasVisiteur,
        clotureChat: this.clotureChat,
        fullPath: this.$route.fullPath
      })
      this.fermeDialog()
    },

    settingsFromCookies () {
      this.formulaireSatisfaction = this.$cookie.get('wz-satisfaction-survey') === 'true' || false
      this.clotureChat = this.$cookie.get('wz-closing-chat') === 'true' || false
    }
  },

  watch: {
    // ----------------------------------------------------------------------------
    // garde des infos sur le visiteur même si il est deconnecté
    // ----------------------------------------------------------------------------
    datasVisiteur: function (val, oldval) {
      if (!val) {
        this.dataWatchVisteur = oldval
      } else {
        this.dataWatchVisteur = val
      }
    },

    formulaireSatisfaction (v) {
      this.$cookie.set('wz-satisfaction-survey', v, { expires: '1Y' })
    },

    clotureChat (v) {
      this.$cookie.set('wz-closing-chat', v, { expires: '1Y' })
    }

  },

  mounted () {
    // au chargement on recupere le 'datavisiteur'
    // car le 'dataWatchVisiteur' est vide, pas encore passé dans le watch
    this.dataWatchVisteur = this.datasVisiteur
    if (this.dataWatchVisteur.network === 'facebook') {
      this.visitorLeft = 'no'
    }

    if (this.$store.state._User.entKey === '9c44184c124fda32ac19523ff93d2488') {
      this.checkForMotif = true
    }

    this.settingsFromCookies()
    this.id_conversation = 'conversation_' + this.datasVisiteur.visiteurID
  },

  beforeDestroy () {
  },

  computed: {
    ...mapState('_StoreWatcheeBox', [
      'listeAllVisiteurs',
      'sessionsPrivees'
    ]),
    ...mapState('_User', ['entLevel']),
    ...mapGetters('_User', ['user', 'fullName']),
    ...mapGetters('_StoreWatcheeBox', ['WATCHEEBOX_STATE']),

    hasMotif () {
      // let thisVisit = _.find(this.$store.state._StoreWatcheeBox.listeAllVisiteurs, {
      //   visiteurID: this.dataWatchVisteur.visiteurID
      // })
      // return thisVisit ? thisVisit.motif : false
      return true
    },

    // bloque l'envois du formulaire de satisfaction si pas la bonne licence
    checkSatisfaction () {
      let inactif = false
      if (this.entLevel === '10' || this.entLevel === '1') {
        inactif = true
      }
      return inactif
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheebox/WzDialogCloseChat.vue